import './MessagesNew.scss';

import { useLocation, useNavigate } from '@reach/router';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ModalDialog from '../../../../../../components/modals/ModalDialog/ModalDialog';
import NotEnoughCredits from '../../../../../../components/modals/NotEnoughCredits/NotEnoughCredits';
import PurchaseCredits from '../../../../../../components/modals/PurchaseCredits/PurchaseCredits';
import {
  DISMISS_NOTIFICATION,
  SET_NOTIFICATIONS,
} from '../../../../../../redux/types/notifications';
import {
  clearFailedMessages,
  getSingleConversationByID,
} from '../../../../../../services/message-services/message.services';
import { markNotificationAsRead } from '../../../../../../services/notification-service/notification-service';
import { getInboxProfileById } from '../../../../../../services/profile-service/profile.service';
import { getToken } from '../../../../../../services/token-service/token.service';
import { getUserData } from '../../../../../../services/user-service/user.service';
import Conversation from './Conversation/Conversation';
import ListOfConversations from './ListOfConversations/ListOfConversations';
import ProfileInfo from './ProfileInfo/ProfileInfo';

const MessagesNew = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const notEnoughCredistRef = useRef(null);
  const purchaseCreditsRef = useRef(null);
  const getUrl = window.location.pathname;
  const selectedProfileId = getUrl.split('/').pop();
  const [selectedProfileData, setSelectedProfileData] = useState();
  const [conversation, setConversation] = useState();
  const [loadingConversation, setLoadingConversation] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false);
  const { newConversationId } = useSelector((state) => state);
  const { newMessages } = useSelector((state) => state);
  const [mobileComponentActive, setMobileComponentActive] = useState(newConversationId ? 1 : 0);
  const token = getToken();
  const dispatch = useDispatch();
  const userData = getUserData();

  useEffect(() => {
    const newLoc = location.pathname;
    const parts = newLoc.split('/');
    const urlArray = parts.map((item) =>
      item === 'messages' ? item.replace('messages', 'messagesnew') : item,
    );
    const url = urlArray.join('/');
    navigate(url);
  }, [location]);

  useEffect(() => {
    selectedProfileId && setMobileComponentActive(Number(selectedProfileId) > 0 ? 1 : 0);
  }, [selectedProfileId]);

  const openModal = (ref) => {
    ref.current.openModal();
  };

  const closeModal = (ref) => {
    ref.current.closeModal();
  };

  useEffect(() => {
    clearFailedMessages();
  }, [window.location.pathname]);

  useEffect(() => {
    setLoadingProfile(false);
    const getProfileDataFailed = (err) => {
      console.log(err);
    };
    const getProfileDataSuccess = (res) => {
      setSelectedProfileData(res.data);
      setLoadingProfile(true);
    };

    Number(selectedProfileId) &&
      token &&
      getInboxProfileById(selectedProfileId)
        .then(getProfileDataSuccess)
        .catch(getProfileDataFailed);
  }, [selectedProfileId, token]);

  useEffect(() => {
    setLoadingConversation(false);
    setConversation();
    const getConversationFailed = (err) => {
      console.log(err);
    };
    const getConversationSuccess = (res) => {
      setLoadingConversation(true);
      setConversation(res.data.messages.data);
    };
    newConversationId?.conversationId &&
      getSingleConversationByID(newConversationId?.conversationId, getToken)
        .then(getConversationSuccess)
        .catch(getConversationFailed);
  }, [newConversationId?.conversationId]);

  const updateNotificationsLocal = useCallback(
    (noteIdArr, notificationNumber) => {
      // const notifications = userData.unread_notifications;
      // const newNotifications = notifications.filter(
      //   (note) => !noteIdArr.includes(note.id)
      // );
      const dataFromLocalStorage = JSON.parse(localStorage.getItem('userData'));
      const messageNotifications =
        Number(dataFromLocalStorage?.unread_message_notifications) > 0
          ? Number(dataFromLocalStorage?.unread_message_notifications) - notificationNumber
          : 0;
      const newDataFromLocalStorage = {
        ...dataFromLocalStorage,
        unread_message_notifications: messageNotifications,
      };
      dispatch({
        type: SET_NOTIFICATIONS,
        payload: Number(messageNotifications) || '',
      });
      localStorage.setItem('userData', JSON.stringify(newDataFromLocalStorage));
    },
    [userData?.unread_message_notifications],
  );

  // za poruke sa webSocket-a
  useEffect(() => {
    if (newMessages[newConversationId?.conversationId]) {
      const receivedMessage = {
        attachments: newMessages[newConversationId?.conversationId].attachments,
        body: newMessages[newConversationId?.conversationId].body,
        created_at: newMessages[newConversationId?.conversationId].created_at,
        image: newMessages[newConversationId?.conversationId].image,
        sender_profile_id: newMessages[newConversationId?.conversationId].sender_profile_id,
      };

      setConversation((prev) => prev && [receivedMessage, ...prev]);
      markNotificationAsRead(newConversationId?.conversationId, token)
        .then(() => {
          updateNotificationsLocal(
            [newMessages[newConversationId?.conversationId]?.notification?.id],
            1,
          );
          selectedProfileData.online_status = 1;
          // getSelectedProfileData(selectedProfileData)
          dispatch({
            type: DISMISS_NOTIFICATION,
            payload: newConversationId,
          });
        })
        .catch((err) => console.log(err));
    }
  }, [newMessages]);

  const renderLoadingConversationLoader = () => {
    return (
      <div className="LoaderConvComponent">
        <div className="loadingContainer">
          {/* <img src={loaderImage}  className="loader"/> */}
          <svg
            className="loader"
            width="250"
            height="70"
            viewBox="0 0 33 42"
            fill="#9f0220"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.0813 6.24073C27.7161 6.11931 26.3262 6.37671 26.86 6.02217C27.3946 5.66691 27.8539 5.20799 28.2115 4.67204C28.5725 4.13244 28.8212 3.52441 28.9425 2.88482C29.0681 2.2533 29.0681 1.60284 28.9425 0.971319C28.8681 0.638526 28.7634 0.313375 28.6299 0C29.2657 0.425453 29.797 0.991876 30.1833 1.6561C30.5653 2.32826 30.7844 3.08212 30.8229 3.85614C30.8656 4.61805 30.7323 5.37956 30.4333 6.08045C30.1295 6.78002 29.6665 7.39735 29.0819 7.88226C28.4945 8.36926 27.803 8.71175 27.062 8.88272C26.3166 9.05755 27.543 8.54761 26.7879 8.36792C26.0328 8.18822 27.2688 8.4262 26.6677 7.93083C26.0791 7.4416 25.6129 6.81936 25.3066 6.11445C26.3935 6.8138 25.8068 6.49327 27.0813 6.24073Z"
              fill="#9f0220"
            />
            <path
              d="M5.63186 6.24073C5.00184 6.11931 6.38692 6.37671 5.85309 6.02217C5.31967 5.66552 4.86056 5.20685 4.50168 4.67204C4.14411 4.13111 3.89721 3.52347 3.77547 2.88482C3.64799 2.25348 3.64799 1.60266 3.77547 0.971319C3.84558 0.637351 3.95036 0.311778 4.08808 0C3.45111 0.424122 2.91954 0.990833 2.53468 1.6561C2.15064 2.32738 1.93132 3.08175 1.89504 3.85614C1.84739 4.61834 1.98096 5.38099 2.2846 6.08045C2.5888 6.77851 3.04985 7.39542 3.6312 7.88226C4.21986 8.37024 4.91313 8.7128 5.6559 8.88272C6.39653 9.05755 5.17498 8.54761 5.93003 8.36792C6.68509 8.18822 5.44911 8.4262 6.05027 7.93083C6.63737 7.44023 7.10333 6.81835 7.41129 6.11445C6.32439 6.8138 6.90632 6.49327 5.63186 6.24073Z"
              fill="#9f0220"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.3569 13.7588C31.395 9.49471 28.2738 5.72113 24.84 3.5988C19.9874 0.607137 14.173 1.1365 11.3451 2.03011C9.30631 2.68801 7.41831 3.75087 5.79212 5.15621C4.16592 6.56154 2.83433 8.28099 1.87564 10.2135C0.796606 12.423 0.170122 14.8298 0.0336879 17.2895C-0.129828 19.9558 0.264534 22.8843 1.7506 25.3223C2.79903 27.0513 5.34314 29.771 8.00267 32.447C10.6622 35.123 13.5622 37.8378 15.6975 39.829H13.7738C13.5187 39.829 13.2741 39.9313 13.0937 40.1135C12.9133 40.2957 12.812 40.5427 12.812 40.8003C12.812 41.0579 12.9133 41.305 13.0937 41.4871C13.2741 41.6693 13.5187 41.7716 13.7738 41.7716H18.6793C18.9344 41.7716 19.179 41.6693 19.3594 41.4871C19.5398 41.305 19.6411 41.0579 19.6411 40.8003V36.5362C19.6411 36.2786 19.5398 36.0316 19.3594 35.8494C19.179 35.6672 18.9344 35.5649 18.6793 35.5649C18.4242 35.5649 18.1795 35.6672 17.9991 35.8494C17.8188 36.0316 17.7174 36.2786 17.7174 36.5362V37.7504C15.5917 35.7543 12.6773 33.0103 10.0514 30.3781C7.31494 27.6535 5.04496 25.1669 4.20815 23.7974C3.13568 22.0393 2.76536 19.7713 2.91445 17.4838C3.02721 15.4297 3.54383 13.4188 4.43418 11.5685C5.21855 9.97795 6.3103 8.56209 7.64507 7.40437C8.97984 6.24664 10.5306 5.37048 12.206 4.82752C14.5433 4.08932 19.4199 3.68622 23.3347 6.09994C26.2202 7.88717 28.7836 11.0537 29.5386 14.4193C30.337 17.9549 29.5098 22.6755 27.0426 25.5895C26.0471 26.7502 23.9454 29.0765 22.4834 30.5675C20.1461 28.3432 17.2221 25.3903 14.7212 22.7678C13.2785 21.2622 11.9992 19.8538 11.0469 18.8048C10.566 18.2657 10.1861 17.8335 9.91196 17.4838C9.77249 17.3138 9.67149 17.1827 9.60416 17.0856L9.55126 17.0127C9.31408 16.5114 9.22876 15.9505 9.30599 15.4003C9.42806 14.82 9.72549 14.2923 10.1572 13.8899C10.5261 13.5587 10.9888 13.3532 11.4798 13.3023C11.984 13.217 12.502 13.3097 12.9466 13.5645C13.8054 14.1888 14.5548 14.9537 15.1637 15.8277C15.2911 16.0119 15.459 16.1639 15.6542 16.2718C15.8494 16.3796 16.0667 16.4404 16.2891 16.4493C16.5107 16.4585 16.7314 16.416 16.9341 16.325C17.1368 16.234 17.316 16.0971 17.4577 15.9248C17.9487 15.3309 18.4738 14.7665 19.0304 14.2347C19.275 13.996 19.5336 13.7722 19.8047 13.5645C19.8989 13.492 19.9986 13.4271 20.1028 13.3703C21.0647 13.0886 22.0506 13.0934 22.6277 13.7928C23.0084 14.1882 23.2731 14.6824 23.3924 15.2206C23.4399 15.7726 23.299 16.3244 22.9932 16.7845C22.535 17.5114 22.0135 18.1956 21.435 18.8291C20.704 19.679 19.9057 20.5289 19.3718 21.068C19.1016 21.3412 18.9499 21.7115 18.9499 22.0976C18.9499 22.4837 19.1016 22.854 19.3718 23.1272C19.5059 23.263 19.6651 23.3708 19.8405 23.4443C20.0159 23.5178 20.2039 23.5557 20.3938 23.5557C20.5837 23.5557 20.7717 23.5178 20.9471 23.4443C21.1225 23.3708 21.2817 23.263 21.4158 23.1272C21.9929 22.5444 22.8345 21.6411 23.6088 20.7426C24.3302 19.9506 24.9744 19.0902 25.5325 18.1734C26.14 17.1526 26.3922 15.956 26.2491 14.7738C26.0509 13.7079 25.5649 12.7179 24.8448 11.9133C23.0605 9.7521 20.4202 10.2329 19.2949 10.5583C18.8594 10.7024 18.4525 10.9227 18.0926 11.2091C17.7303 11.484 17.3835 11.7791 17.0537 12.093C16.8325 12.3067 16.6113 12.5252 16.3997 12.7486C15.8305 12.1123 15.1842 11.551 14.476 11.078C13.4645 10.4673 12.2757 10.2272 11.1095 10.398C9.98493 10.5303 8.93341 11.028 8.11329 11.8162C7.26024 12.6427 6.68362 13.7174 6.4637 14.8904C6.2895 16.0293 6.457 17.1947 6.94463 18.2366C7.03561 18.4324 7.14685 18.618 7.27647 18.7902C7.39189 18.9456 7.53136 19.1253 7.68526 19.3196C7.99786 19.7033 8.41627 20.1889 8.90682 20.7377C9.86867 21.8402 11.2008 23.2534 12.6484 24.7736C15.534 27.8041 19.0111 31.3008 21.536 33.6368C21.8005 33.8758 22.143 34.0079 22.4979 34.0079C22.8527 34.0079 23.1952 33.8758 23.4597 33.6368C24.8736 32.3304 27.9516 28.9454 29.2309 27.469C32.3906 23.7682 33.3187 18.0375 32.3569 13.7588Z"
              fill="#9f0220"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1733_6051"
                x1="15.3416"
                y1="42.2087"
                x2="17.0826"
                y2="1.19621"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#AA170E" />
                <stop offset="1" stopColor="#D41411" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        Your flirts are loading
      </div>
    );
  };

  return (
    <div className="MessagesInbox">
      <div className="MessagesContainer">
        <ListOfConversations
          conversation={conversation}
          setConversation={setConversation}
          setMobileComponentActive={setMobileComponentActive}
          mobileComponentActive={mobileComponentActive}
        />
        {selectedProfileData && Number(selectedProfileId) && loadingProfile ? (
          <>
            <Conversation
              selectedProfileData={selectedProfileData}
              conversation={conversation}
              setConversation={setConversation}
              loadingConversation={loadingConversation}
              setLoadingConversation={setLoadingConversation}
              openModal={openModal}
              notEnoughCredistRef={notEnoughCredistRef}
              purchaseCreditsRef={purchaseCreditsRef}
              setMobileComponentActive={setMobileComponentActive}
              mobileComponentActive={mobileComponentActive}
            />
            <ProfileInfo
              selectedProfileData={selectedProfileData}
              setMobileComponentActive={setMobileComponentActive}
              mobileComponentActive={mobileComponentActive}
            />
          </>
        ) : !loadingProfile && getUrl !== '/members-area/messages' ? (
          renderLoadingConversationLoader()
        ) : (
          ''
        )}
      </div>
      <div className="NotEnoughCreditsModalContainer">
        <ModalDialog ref={notEnoughCredistRef} hideLogo={true}>
          <NotEnoughCredits
            closeModal={closeModal}
            openModal={openModal}
            modalRef={notEnoughCredistRef}
            username={selectedProfileData?.username}
            photo={selectedProfileData?.avatar_url}
            purchaseCreditsRef={purchaseCreditsRef}
          />
        </ModalDialog>
        <ModalDialog className="NoCredits-Modal" ref={purchaseCreditsRef} hideLogo={true}>
          <PurchaseCredits closeModal={closeModal} modalRef={purchaseCreditsRef} />
        </ModalDialog>
      </div>
    </div>
  );
};

export default MessagesNew;
